import React from 'react';
import PropTypes from 'prop-types';
import { Select, useTheme } from '@ublend-npm/aulaui-core';

interface SpacesSortSelectProps {
  value: 'az' | 'za';
  onChange: (value: 'az' | 'za') => void;
}

const SpacesSortSelect: React.FC<SpacesSortSelectProps> = ({
  value,
  onChange,
}) => {
  const theme = useTheme();

  const textColor = theme.palette.text.secondary;

  return (
    <Select
      label=""
      value={value}
      onChange={(e) => onChange(e.target.value)}
      options={[
        { value: 'az', label: 'Sort: A-Z' },
        { value: 'za', label: 'Sort: Z-A' },
      ]}
      sx={{
        width: '140px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Roboto, sans-serif',
        mt: 0,
        color: textColor,
        '& .MuiOutlinedInput-input': {
          color: textColor,
        },
      }}
      inputProps={{ 'aria-label': 'Sort spaces alphabetically' }}
    />
  );
};

SpacesSortSelect.propTypes = {
  value: PropTypes.oneOf(['az', 'za']).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SpacesSortSelect;
